let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5By5M")).then(() => parcelRequire('lVQSJ'));